<template>
  <div>
    <div class="row align-items-end">
      <div class="col col-12 col-md-6 col-xl-4">
        <div class="form-group field">
          <c-input v-model="position" type="select" :items="positions" label="Для какой должности создать анкету" />
        </div>
      </div>
      <div class="col col-12 col-md-auto">
        <div class="form-group apply">
          <c-button color="primary" label="Применить" :disabled="pending" :pending="pending" @click="apply" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CInput from "@/components/controls2/Input";
import CButton from "@/components/controls2/Button";

export default {
  name: "positions-view",
  components: { CInput, CButton },

  props: ["positions"],

  data() {
    return {
      pending: false,
      position: null,
    };
  },

  created() {
    this.position = this.positions[0];
  },

  methods: {
    async apply() {
      this.pending = true;
      await this.$store.dispatch("personalEmployee/setUserProfile", this.position.value);
      this.pending = false;
      this.$emit("update");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

@include beforeBootstrapMd {
  .apply {
    /deep/ {
      .c-button {
        width: 100%;
      }
    }
  }
}
</style>
